import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { NavLink } from "react-router-dom";
import { boxInfoRegisteredStyle } from "./style";
import { useNewOffer } from "../../../../../context/new-offer";
import {
	floatFormat,
	formatCurrency,
	intFormat
} from "../../../../../../shared/create-offer/utils/formats";
import TooltipOffers from "../../../../../../shared/create-offer/TooltipOffers/TooltipOffers";
import { ROUTE_ACCOUNT_DETAILS } from "../../../../../shared/constants";
import { AIRLINE_PROGRAMS } from "../../../../../shared/enums";
import { getStartAverage, formatPhone } from "../../../../../shared/utils";

const CreateInfoRegistered = props => {
	const [totalExpectedGain, setTotalExpectedGain] = useState(0);

	const {
		currentProgram,
		offerData,
		rankingData,
		bankData,
		editOffer,
		creditCardData,
		banks,
		smilesDiamond,
		bonusData: { data: bonusData },
		participantData,
		loyaltyData
	} = useNewOffer();

	const [showCreditCard] = useState(
		currentProgram &&
			currentProgram.international === "1" &&
			(currentProgram.id == 25 ||
				currentProgram.id == 11 ||
				currentProgram.id == 10 ||
				currentProgram.id == 14)
	);

	const { price, quant, averageMiles, reductions } = offerData.data;
	const { phone, isMaxPhone } = loyaltyData.data;
	const { countAllowedSales } = rankingData.data;
	const { agency, cpfcnpj, account, bankId, type } = bankData.data;
	const bankName = banks.data.find(val => val.idBank == bankId);

	const isQuickSale = editOffer && editOffer.quickSale;
	const forwardPayment = editOffer.forwardPayment;

	const bonusValid =
		!isQuickSale &&
		bonusData.enabled &&
		quant >= bonusData.minMiles &&
		countAllowedSales >= bonusData.minCPFs &&
		averageMiles >=
			getStartAverage(quant, countAllowedSales, bonusData.minAverage, bonusData.maxAverage) &&
		averageMiles <= bonusData.maxAverage;

	let maxSales = parseInt(quant / averageMiles);
	if (maxSales > countAllowedSales) {
		maxSales = countAllowedSales;
	}

	const showReduction = () => {
		return quant >= 60000 && currentProgram.id === AIRLINE_PROGRAMS.SMILES.id && smilesDiamond && !!reductions;
	};

	const isLatam = () => {
		return currentProgram.id === 3 || currentProgram.id === 1;
	};

	const isWrongLatamPhone = isLatam() && (isMaxPhone === 0 || isMaxPhone === -1);

	const tabEditHandle = tab => {
		if (tab == "bank") {
			localStorage.setItem("editBankSelected", "1");
		} else if (tab == "card") {
			localStorage.setItem("editCardSelected", "1");
		}
	};

	useEffect(() => {
		setTotalExpectedGain((parseInt(quant) / 1000) * floatFormat(price.toString()));
	}, []);

	return (
		<div
			className={css`
				${boxInfoRegisteredStyle};
			`}
		>
			<div className="resume-row d-flex">
				<div className="title-group">
					<p>Dados da oferta</p>
				</div>

				<div className="area-infos">
					<div>
						<p className="col-xs-16 no-padding program-fidelity">
							<strong>{currentProgram.acronym}</strong> <span>({currentProgram.fidelityName})</span>
						</p>
					</div>
					<div className="miles-row d-flex">
						<div className="area-total-expected-gain">
							<div className="col-xs-16 col-sm-8 no-padding">
								<p className="title">{`${
									forwardPayment ? "Você vai receber" : "Você pode receber até"
								}`}</p>
								<div className="box-price">
									<p className="box-price--currency value">
										R$ {formatCurrency(totalExpectedGain)}
									</p>
									<div className="box-price--tooltip">
										<TooltipOffers
											position="bottom-end"
											content={
												<p style={{ fontWeight: "bold", textAlign: "left" }}>
													Valor total a receber caso venda todas as milhas.
												</p>
											}
										/>
									</div>
								</div>
							</div>
							{bonusValid && (
								<div className="col-xs-16 col-sm-8 no-padding">
									<p>Bônus</p>
									<p className="title-bf">
										<strong className="value">
											+R$ {formatCurrency(maxSales * bonusData.value)}
										</strong>
									</p>
								</div>
							)}
						</div>

						<div className="col-xs-16 col-sm-8 no-padding">
							<p className="title">Valor a cada 1.000 milhas</p>
							<p className="value">R$ {formatCurrency(price)}</p>
						</div>

						<div className="col-xs-16 col-sm-8 no-padding">
							<p className="title">Quantidade de milhas</p>
							<p className="value">{intFormat(quant)} milhas</p>
						</div>

						{(currentProgram.international != 1 || currentProgram.id === AIRLINE_PROGRAMS.TAP.id) && quant >= 60000 && (
							<div className="col-xs-16 col-sm-8 no-padding">
								<p className="title">Média por passageiro</p>
								<p className="value">{intFormat(Math.floor(averageMiles / 500) * 500)} milhas</p>
								{/* {averageMiles % 500 > 0 && (
								<div className="box-price--tooltip">
									<TooltipOffers
										position="bottom-end"
										content={
											<p style={{ fontWeight: "bold", textAlign: "left" }}>
												Sua média foi arredondada para multiplos de 500.
											</p>
										}
									/>
								</div>
							)} */}
							</div>
						)}

						{showReduction() && (
							<div className="col-xs-16 col-sm-8 no-padding">
								<p className="title">Reduções de milhas</p>
								<p className="value">
									{reductions == 1 ? `${reductions} passagem` : `${reductions} passagens`}
								</p>
							</div>
						)}
					</div>
				</div>

				{isLatam() && props.typePhoneLatam === 0 && (
					<div className="col-xs-16 phoneLatam-row no-padding">
						<div className="col-xs-16 bank-details no-padding">
							<p className={isWrongLatamPhone ? "wrong-latam-phone" : ""}>Telefone LATAM Pass</p>
							<p className={`values ${isWrongLatamPhone ? "wrong-latam-phone" : ""}`}>
								{formatPhone(phone)}
							</p>
						</div>
					</div>
				)}

				{!participantData.hasManagementActive && (
					<div className="col-xs-16 no-padding bank-row d-flex">
						<div className="col-xs-16 no-padding">
							<p className="col-xs-12 title-group no-padding">Dados da Bancários </p>
							<div className="bank-details--edit col-xs-4">
								<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
									<div
										onClick={() => tabEditHandle("bank")}
										className="bank-details--edit--link"
										data-action="finished-offer-edit-bank"
									>
										<strong>Editar</strong>
									</div>
								</NavLink>
							</div>
						</div>

						<div className="col-xs-8 no-padding bank-details">
							<p className="title">Banco</p>
							<span className="values">{bankName.name}</span>
						</div>
						<div className="col-xs-8 no-padding bank-details">
							<p className="title">Agência</p>
							<span className="values">{agency}</span>
						</div>
						<div className="col-xs-8 no-padding bank-details">
							<p className="title">Conta corrente</p>
							<span className="values">{account}</span>
						</div>
						<div className="col-xs-8 no-padding bank-details">
							<p className="title">CPF/CNPJ</p>
							<span className="values">
								{cpfcnpj.length <= 14
									? cpfcnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
									: cpfcnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5")}
							</span>
						</div>
					</div>
				)}

				{showCreditCard && (
					<div className="col-xs-16 no-padding cc-row d-flex">
						<div className="col-xs-16 no-padding">
							<p className="col-xs-12 title-group no-padding">Dados do Cartão de Crédito</p>
							<div className="bank-details--edit col-xs-4">
								<NavLink to={`${ROUTE_ACCOUNT_DETAILS}`}>
									<div
										onClick={() => tabEditHandle("card")}
										className="cc-details--edit--link"
										data-action="finished-offer-edit-credit-card"
									>
										<strong>Editar</strong>
									</div>
								</NavLink>
							</div>
						</div>

						<div className="col-xs-8 no-padding cc-details">
							<p className="title">Número</p>
							<span className="values">
								**** **** ****{" "}
								{(creditCardData.data.cardNumber &&
									creditCardData.data.cardNumber.substring(0, 4)) ||
									creditCardData.data.number}
							</span>
						</div>
						<div className="col-xs-8 no-padding cc-details">
							<p className="title">Nome</p>
							<span className="values">
								{creditCardData.data.holderName || creditCardData.data.name}
							</span>
						</div>
						<div className="col-xs-8 no-padding cc-details">
							<p className="title">CPF</p>
							<span className="values">
								{creditCardData.data.cardCpf || creditCardData.data.cpf}
							</span>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default CreateInfoRegistered;
